import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import VueRouter from "vue-router";
import router from "./router";
import kindeditor from "@/components/kindeditor.vue";
import store from "./store";
import VueUeditorWrap from "vue-ueditor-wrap";
import VueClipboard from "vue-clipboard2";
Vue.config.productionTip = false;
Vue.component("VueUeditorWrap", VueUeditorWrap);
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.component("kindeditor", kindeditor);
Vue.use(VueClipboard);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
